export default "__VITE_ASSET__D5ai6I2e__"